// 底部栏 协议列表
export const AGREEMENT_LIST = [
  {
    title: '隐私协议',
    link: 'https://static-platform.codemao.cn/926/protocols/_privacyProtocol.html',
  },
  {
    title: '儿童隐私协议',
    link: 'https://static-platform.codemao.cn/926/protocols/_childrenPrivacyProtectProtocol.html',
  },
  {
    title: '个人信息保护政策摘要',
    link: 'https://static-platform.codemao.cn/926/protocols/_informationProtectionPolicySummary.html',
  },
  {
    title: '个人信息收集清单',
    link: 'https://static-platform.codemao.cn/926/protocols/_informationCollectionList.html',
  },
  {
    title: '个人信息共享清单',
    link: 'https://static-platform.codemao.cn/926/protocols/_informationSharingList.html',
  },
]
